export default {
  title: 'SEO',
  subtitle:
    'Personaliza el título y la descripción que aparecen en los resultados de Google y en las vistas previas en redes sociales. Déjalos vacíos para usar los valores predeterminados.',
  fields: {
    title: {
      label: 'Título de página',
      placeholder: 'p. ej. Forza Napoli — auténtica pizza napolitana en Múnich',
      help: 'Se muestra como titular en Google y en las pestañas del navegador. Máximo 255 caracteres; lo ideal es 50–60 para mejor vista previa.',
    },
    description: {
      label: 'Meta descripción',
      placeholder: 'Breve resumen de tu restaurante que aparecerá bajo el título en los resultados de búsqueda.',
      help: 'Hasta 500 caracteres; Google suele mostrar 150–160. Destaca lo que hace único a tu restaurante.',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    saved: 'Configuración SEO guardada',
    failed: 'Error al guardar la configuración SEO',
  },
};
